import { MELoginResponse } from './login';

type OnLoginHandler = (response: MELoginResponse) => void;

const login_handlers: OnLoginHandler[] = [];

export function onLogin(handler: OnLoginHandler) {
    login_handlers.push(handler);
}

export function meTriggerLogin(response: MELoginResponse) {
    for(const p of login_handlers) {
        p(response);
    }
}

type OnLogoutHandler = () => void;

const logout_handlers: OnLogoutHandler[] = [];

export function onLogout(handler: OnLogoutHandler) {
    logout_handlers.push(handler);
}

export function meTriggerLogout() {
    for(const p of logout_handlers) {
        p();
    }
}
